module.exports = __webpack_public_path__ + "img/Foto copia.fc0bf00f.png";